import { Component } from '@theme/component';
import { morph } from '@theme/morph';
import { StandardEvents, ProductSelectEvent } from '@shopify/events';

/**
 * Keeps the product + selected-variant sizing disclosure synchronized with the
 * variant picker. The server remains the source of truth for metafield output.
 *
 * @extends {Component}
 */
class GwVariantSizing extends Component {
  #eventTarget;

  connectedCallback() {
    super.connectedCallback();
    this.#eventTarget = this.closest('.shopify-section, dialog');
    this.#eventTarget?.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#eventTarget?.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  /**
   * Replaces this disclosure with the server-rendered version for the newly
   * selected variant, preserving its open state when content remains present.
   *
   * @param {ProductSelectEvent} event
   */
  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;

        if (detail.newProduct) {
          this.dataset.productId = detail.newProduct.id;
        } else if (detail.productId && detail.productId !== this.dataset.productId) {
          return;
        }

        const nextSizing = [...detail.html.querySelectorAll('gw-variant-sizing')].find(
          (candidate) => candidate.dataset.blockId === this.dataset.blockId
        );

        if (!nextSizing) {
          this.hidden = true;
          this.replaceChildren();
          return;
        }

        const wasOpen = Boolean(this.querySelector('details[open]'));
        morph(this, nextSizing);

        if (wasOpen && !this.hidden) {
          this.querySelector('details')?.setAttribute('open', '');
        }
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[gw-variant-sizing] Event promise rejected:', error);
      });
  };
}

if (!customElements.get('gw-variant-sizing')) {
  customElements.define('gw-variant-sizing', GwVariantSizing);
}
